import React, { useEffect } from 'react';
import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';
import { styles } from './MenuUnderlay.css';

export type MenuUnderlayProps = { onClick: () => void; isOpen: boolean };

export const MenuUnderlay = ({ onClick, isOpen }: MenuUnderlayProps) => {
  const isDesktop = useBreakpoint('md', 'up');

  useEffect(() => {
    if (isOpen && isDesktop) {
      document.body.classList.add(styles.body);
    } else {
      document.body.classList.remove(styles.body);
    }
    return () => {
      document.body.classList.remove(styles.body);
    };
  }, [isOpen, isDesktop]);

  return (
    <button type="button" className={styles.background({ isOpen, isDesktop })} onClick={() => isOpen && onClick()} />
  );
};
